<template>
  <div class="main-view">
    <div class="section shadow filter__wrap">
      <div class="btnAdd">
        <el-button
          :size="subUnitSize"
          type="primary"
          icon="el-icon-plus"
          @click="showAdd"
          >创建</el-button
        >
      </div>
    </div>
    <VTable
      showIndex
      has-pagionation
      :field="field"
      :loading="table.loading"
      :data="table.data"
      :page="table.params.page"
      :pageSize="table.params.count"
      :total="table.total"
      :tree-props="{ children: 'children', hasChildren: 'has_child' }"
      :hasPagionation="true"
      :default-expand-all="true"
      :showSelect="false"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:trade_amount="{ row }">
        <span>￥{{ row.trade_amount }}</span>
      </template>
      <template v-slot:merchant_count="{ row }">
        <el-button type="text" @click="viewBind(row)">{{
          row.merchant_count
        }}</el-button>
      </template>
      <template v-slot:action="{ row }">
        <el-button type="text" @click="showDetails(row)">查看</el-button>
        <el-button type="text" @click="editPass(row)">修改密码</el-button>
        <el-button
          v-if="row.status == 1 && !row.merchant_count"
          type="text"
          @click="toDisabled(row)"
          >禁用</el-button
        >
        <el-dropdown
          v-if="row.status == 1 && row.merchant_count"
          placement="bottom-end"
          @command="handleCommand($event, row)"
          style="margin-left: 10px"
        >
          <el-button v-if="row.status == 1 && row.merchant_count" type="text"
            >禁用</el-button
          >
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">直接禁用</el-dropdown-item>
            <el-dropdown-item command="2">转移并禁用</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button
          v-if="row.status == 2"
          type="text"
          @click="toNotDisabled(row)"
          >启用</el-button
        >
      </template>
    </VTable>
    <add ref="addRef" @refresh="getTable"></add>
    <detailssale ref="detailsRef"></detailssale>
    <editPassWord ref="editPassWordRef"></editPassWord>
    <binds ref="bindsRef" @refresh="getTable"></binds>
    <transfer ref="transferRef" @refresh="getTable"></transfer>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
import add from "./components/add.vue";
import detailssale from "./components/details.vue";
import editPassWord from "./components/editPassWord.vue";
import binds from "./components/binds.vue";
import transfer from "./components/transfer.vue";
export default {
  name: "salesmanIndex",
  components: {
    VTable,
    add,
    binds,
    transfer,
    detailssale,
    editPassWord,
  },
  mixins: [mixinTable],
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      field: [
        { name: "name", label: "业务经理", hidden: false },
        { name: "phone", label: "联系电话", hidden: false },
        { name: "code", label: "邀请码", hidden: false },
        { name: "merchant_count", label: "绑定客户数", hidden: false },
        { name: "trade_count", label: "交易次数", hidden: false },
        { name: "trade_amount", label: "交易金额", hidden: false },
        { name: "create_time", label: "创建时间", hidden: false },
        {
          name: "action",
          label: "操作",
          width: "200",
          fixed: "right",
          hidden: false,
        },
      ],
      table: {
        loading: false,
        params: {
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
      userArr: [],
      dialogVisible: false,
      merchantArr: [],
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    getTable() {
      this.table.loading = true;
      this.$http
        .get("/admin/salesman/list", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          }
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    showAdd() {
      let dom = this.$refs.addRef;
      dom.toggle(true);
    },
    editPass(row) {
      let dom = this.$refs.editPassWordRef;
      dom.toggle(true);
      dom.getDetail(row);
    },
    showDetails(row) {
      let dom = this.$refs.detailsRef;
      dom.toggle(true);
      dom.getDetail(row);
    },
    viewBind(row) {
      if (row.merchant_count == 0) return this.$message.warning("暂无绑定客户");
      let dom = this.$refs.bindsRef;
      dom.toggle(true);
      dom.getDetail(row);
    },
    toDisabled(row) {
      this.$confirm("确定禁用吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$http
            .post("/admin/salesman/operation", { id: row.id, change_id: 0 })
            .then((res) => {
              if (res.code == 1) {
                this.$message.success("操作成功");
                this.getTable();
              }
            });
        })
        .catch(() => {
          return false;
        });
    },
    handleCommand(value, row) {
      if (value == 1) {
        this.$confirm("确定禁用吗", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
          .then(() => {
            this.$http
              .post("/admin/salesman/operation", { id: row.id, change_id: 0 })
              .then((res) => {
                if (res.code == 1) {
                  this.$message.success("操作成功");
                  this.getTable();
                }
              });
          })
          .catch(() => {
            return false;
          });
      } else {
        let dom = this.$refs.transferRef;
        dom.toggle(true);
        dom.getDetail(row);
      }
    },
    toNotDisabled(row) {
      this.$confirm("确定启用吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        this.$http
          .post("/admin/salesman/operation", { id: row.id })
          .then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.getTable();
            }
          });
      });
    },
  },
};
</script>

<style scoped>
.user-list {
  max-height: 300px;
  overflow: auto;
}
.user {
  height: 30px;
  line-height: 30px;
}
</style>
